// #region imports
import React, { FC, ReactNode } from 'react';
import Card, { CardProps } from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import cn from 'classnames';

import styles from './styles';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { ReactComponent as UserIcon } from 'assets/svg/userIcon.svg';

// #endregion

interface IProps extends CardProps {
  headerLabel: string;
  title: string;
  actions?: ReactNode;
}

const WinnerCard: FC<IProps> = ({ headerLabel, title, className, actions, ...rest }) => {
  const classes = styles();
  const { t } = useTranslation();

  return (
    <Card
      className={ cn(className, classes.root) }
      variant="outlined"
      { ...rest }
    >
      <Typography className={ classes.headerLabel } variant="body1">{ headerLabel }</Typography>
      <UserIcon className={ classes.icon }/>
      <Typography className={ classes.title } variant="h5">
        { title }
      </Typography>
      <Typography className={ classes.subtitle } variant="body1">
        1 000 000₸
      </Typography>
      <Button className={ classes.button } variant="contained" color="info">{ t('action.wantTheSame') }</Button>
    </Card>
  );
};

export default WinnerCard;
